module.exports = __webpack_public_path__ + "static/world-26b912fd03a67eb169316a16f6e6b4e4.jpg";